import * as Actions from './constants'

// const addItem = React.useCallback(data => addItem(data, dispatch), [])
// const removeItem = React.useCallback(data => removeItem(data, dispatch), [])
// const updateItem = React.useCallback(data => updateItem(data, dispatch), [])
// const deselectAllItem = React.useCallback(data => deselectAllItem(data, dispatch), [])
// const selectItem = React.useCallback(data => selectItem(data, dispatch), [])
// const setZoom = React.useCallback(data => setZoom(data, dispatch), [])

export function addItem(data, dispatch) {
  let itemKey = getKey(data.item)
  // dispatch({type: Actions.DESELECT_ALL_ITEM})
  switch (itemKey) {
    case 'textbox':
      return dispatch({type: Actions.ADD_ITEM_TEXTBOX, payload: data})
    case 'image':
      return dispatch({type: Actions.ADD_ITEM_IMAGE, payload: data})
    case 'fieldselect':
      return dispatch({type: Actions.ADD_ITEM_FIELD_SELECT, payload: data})
    case 'qrcode':
      return dispatch({type: Actions.ADD_ITEM_QR_CODE, payload: data})
    case 'barcode':
      return dispatch({type: Actions.ADD_ITEM_BAR_CODE, payload: data})
    case 'barcodenotext':
      return dispatch({type: Actions.ADD_ITEM_BAR_CODE_NT, payload: data})
    case 'aplogo':
      return dispatch({type: Actions.ADD_ITEM_AP_LOGO, payload: data})
    case 'companylogo':
      return dispatch({type: Actions.ADD_ITEM_COMPANY_LOGO, payload: data})
    default:
      return
  }
}

export function updateItem(data, dispatch) {
  return dispatch({type: Actions.UPDATE_ITEM, payload: data})
}

export function removeItem(data, dispatch) {
  return dispatch({type: Actions.REMOVE_ITEM, payload: data})
}

export function setZoom(data, dispatch) {
  return dispatch({type: Actions.ZOOM, payload: data})
}

export function deselectAllItem(dispatch) {
  return dispatch({type: Actions.DESELECT_ALL_ITEM, payload: {}})
}

export function selectItem(data, dispatch) {
  return dispatch({type: Actions.SELECT_ITEM, payload: data})
}

export function initialize(data, dispatch) {
  return dispatch({type: Actions.INIT, payload: data})
}

/* AUX */
function getKey(item) {
  return Object.keys(item)[0]
}
